import { TOKEN_COOKIE } from '../services/constants';
import SSRStorage from '../services/storage';

const allowedRoles = ['it-admin', 'medical-director', 'records', 'lab-manager', 'lab-supervisor', 'pharmacy-supervisor'];

export function hasViewSettingsPermission(permissions) {
	return permissions.find(p => p === 'view-settings');
}

export function hasViewSearchMenuPermission(permissions) {
	return permissions.find(p => p === 'search-patient');
}

export const canViewReports = (user, type) => {
	if (['it-admin', 'medical-director', 'records'].includes(user.role.slug)) {
		return true;
	}
	if (type === 'lab') {
		if (['lab-manager', 'lab-supervisor'].includes(user.role.slug)) {
			return true;
		}
	}
	if (type === 'pharmacy') {
		if (['pharmacy-supervisor'].includes(user.role.slug)) {
			return true;
		}
	}

	if (type === 'inventory-audit') {
		if (['inventory-audit'].includes(user.role.slug)) {
			return true;
		}
	}

	if (type === 'hmo-audit') {
		if (['hmo-audit'].includes(user.role.slug)) {
			return true;
		}
	}

	return false;
};

// export const hideActionBtn = (user, type) => {
// 	if (type === 'inventory-audit') {
// 		if (['inventory-audit'].includes(user.role.slug)) {
// 			return false;
// 		}
// 	}

// 	if(type === 'internal-control-audit') {
// 		if (['internal-control-audit'].includes(user.role.slug)) {
// 			return false;
// 		}
// 	}

// 	if (type === 'hmo-audit') {
// 		if (['hmo-audit'].includes(user.role.slug)) {
// 			return false;
// 		}
// 	}

// 	if (type === 'cafeteria-cashier') {
// 		if (['cafeteria-cashier'].includes(user.role.slug)) {
// 			return false;
// 		}
// 	}
// 	return true;
// };

export const hideActionBtn = (user, types) => {
	const allowedTypes = Array.isArray(types) ? types : [types];

	return !allowedTypes.some(type => type === user.role.slug);
};

export const canViewLabOverview = user => {
	if (['it-admin', 'medical-director', 'lab-manager'].includes(user.role.slug)) {
		return true;
	}
	return false;
};

export const hideMultipleMenu = user => {
	if (['it-admin', 'medical-director', 'records'].includes(user.role.slug)) {
		return false;
	}
	return true;
};

export const checkHOD = async () => {
	const user = await new SSRStorage().getItem(TOKEN_COOKIE);
	return user?.details?.department?.staff?.id === user?.details?.id || allowedRoles.includes(user.role?.slug);
};

export const checkHOU = async () => {
	const user = await new SSRStorage().getItem(TOKEN_COOKIE);
	return user?.details?.unit?.unithead?.id === user?.details?.id || allowedRoles.includes(user.role?.slug);
};
